import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=5cb49d5d&scoped=true&"
import script from "./vipList.vue?vue&type=script&lang=js&"
export * from "./vipList.vue?vue&type=script&lang=js&"
import style0 from "./vipList.vue?vue&type=style&index=0&id=5cb49d5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb49d5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb49d5d')) {
      api.createRecord('5cb49d5d', component.options)
    } else {
      api.reload('5cb49d5d', component.options)
    }
    module.hot.accept("./vipList.vue?vue&type=template&id=5cb49d5d&scoped=true&", function () {
      api.rerender('5cb49d5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/vip/vipList.vue"
export default component.exports